import { render, staticRenderFns } from "./IconLogic.vue?vue&type=template&id=f6d6e22c&"
import script from "./IconLogic.vue?vue&type=script&lang=ts&"
export * from "./IconLogic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports